export function FeedSkeleton() {
  return (
    <div className="feed-stack" aria-label="Loading feed">
      {Array.from({ length: 3 }).map((_, index) => (
        <div className="post skeleton" key={index}>
          <div className="post-head"><span /><div /></div>
          <div className="media-box" />
          <div className="lines"><i /><i /><i /></div>
        </div>
      ))}
    </div>
  );
}
